import React, { useEffect, useState } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  CheckboxBase,
} from "@reusejs/react";
import { getAuctionEventByUuid, updateBidderForEvent } from "services";
import Loader from "../../../layouts/Loader";
import { useRouter } from "next/router";
import { ChevronDoubleRightIcon } from "@heroicons/react/outline";

const TermsAndCondition = ({ bidderData, id, currentStep, nextStep }: any) => {
  const [event, setEvent] = useState<any>();
  const router = useRouter();
  const form = useBetaForm({
    accept_terms_condition: false,
    terms_condition_data: [],
  });

  const terms_condition_data = [
    {
      header: "EMD and Other Payment Terms :",
      messages: [
        {
          content:
            "To participate in the e-Auction, a non-refundable Earnest Money Deposit (EMD) is required to show serious intent to purchase the property. Typically, the EMD is 10% of the Reserve Price, but this may vary. ICICI Bank may refuse any demand draft/Pay Order if its realization is doubtful.",
        },
        {
          content: `If EMD payment type is chosen as Pay Order/Demand Draft by '${event?.bank?.name}' DD PO The Pay Order/Demand Draft should be purchased by the bidders and drawn on a Scheduled/Nationalised Bank favoring '${event?.bank?.name}'.” Payable at respective property location.`,
        },
        {
          // header: "Payment terms",
          content: "If EMD payment type is chosen as online transfer",
        },
        {
          content:
            "For the successful bidder, the EMD will be part of the sale price, while for unsuccessful bidders, it will be returned without interest. The successful bidder must pay 25% of the sale price (including EMD) within 24 hours of the auction and the remaining 75% within 15 days. Failure to pay will result in forfeiture of the deposited amount, and the property will be re-auctioned.",
        },
        {
          content:
            "Bidders must follow local regulations for property transfer or use. If the property is sold for more than ₹50 Lakhs, TDS must be paid as follows:",
          sub_content: [
            {
              content: "Borrower With PAN: 1% of sale proceeds.",
            },
            {
              content: "Borrower Without PAN: 20% of sale proceeds.",
            },
            {
              content:
                "If multiple bidders each hold less than ₹50 Lakhs, each must pay TDS on their share.",
            },
            {
              content:
                "For properties owned by NRIs, TDS is deducted as per Section 195 of the Income Tax Act, 1961",
            },
          ],
        },
        {
          content: `I/We hereby acknowledge that I/we have thoroughly reviewed the terms and conditions outlined in the tender documents and consent to participate in the auction for the online sale of the immovable secured asset belonging to '${event?.borrower_name}', located at '${event?.event_name}', on an "As is where is", "As is what is", and "Whatever there is" basis.`,
        },
        {
          content:
            "I/We have personally inspected the immovable secured asset/s and affirm that I/we are entirely satisfied with their condition and type. Furthermore, I/we understand that upon placing a bid, I/we are legally obligated to purchase the immovable secured asset at the specified price.",
        },
        {
          content:
            "Should any of the aforementioned information be found to be inaccurate or incomplete, I/we acknowledge that my/our participation may be subject to cancellation by the Authorized Officer at any time, and I/we shall not be entitled to any claims or refunds arising from such circumstances.",
        },
      ],
    },
    {
      header:
        "General Terms & Conditions for e-Auction of Immovable Secured Assets",
      messages: [
        {
          content: `
            The online sale of immovable secured assets through e-Auction is on an "As is where is," "As is what is," and "Whatever there is" basis, without warranties or indemnities. Bidders must inspect the assets before bidding.
          `,
        },
        {
          content: `
            These assets are taken under the SARFAESI Act, 2002, by '${event?.bank?.name}'. The bank can withdraw any asset from sale before confirming a successful bid without explanation.
          `,
        },
        {
          content: `
            Announcements during the e-auction, including changes to the conditions or items for sale, are binding on bidders. Movable items on the immovable assets will not be sold in the e-Auction unless specified separately.
          `,
        },
        {
          content: `
            Bidders may inspect documents related to the assets at the '${event?.bank?.name}' branch mentioned in the Public Notice – Tender cum Auction for Sale of Secured Assets.
          `,
        },
        {
          content: `
            To the best knowledge of the Authorized Officer, there are no encumbrances on the assets. However, bidders must independently verify the title, encumbrances, and claims on the assets before bidding. The bank is not responsible for third-party claims.
          `,
        },
        {
          content: `
            Bidders cannot withdraw their bid or raise complaints about discrepancies after acceptance. Once a bid is accepted, the bidder is deemed to have accepted all terms and waived objections.
          `,
        },
        {
          content: `
            Payments must be made via Demand Draft/Pay Order in favor of '${event?.bank?.name}' payable at Bengaluru. These must be deposited at the specified '${event?.bank?.name}' branch and a scanned copy uploaded to the web portal during bid submission.
          `,
        },
        {
          content: `
            For assistance with creating Login ID & Password, uploading data, submitting Bid Documents, or training on Online Bidding, bidders can contact the e-auction vendor or the '${event?.bank?.name}' Authorized Officer as detailed in the Public Notice.
          `,
        },
        {
          content: `
            Bidders should avoid last-minute bidding to prevent technical issues. The bank or auction portal is not responsible for technical failures.
          `,
        },
        {
          content: `
            The successful bidder bears all dues like electricity, water bills, property taxes, society charges, stamp duties, and other fees for transferring the asset.
          `,
        },
        {
          content: `
            If the borrower's dues are settled before the sale, the auction will be withdrawn.
          `,
        },
        {
          content: `
            The Authorized Officer reserves the right to accept or reject any bid, postpone, or cancel the auction without explanation.
          `,
        },
        {
          content: `
            Bidders should review detailed e-Auction terms on the vendor's web portal before bidding.
          `,
        },
        {
          content: `
            The successful bidder assumes risk for the asset from the date of full payment and is liable for any damages or loss.
          `,
        },
        {
          content: `
            The sale is subject to confirmation by '${event?.bank?.name}'.
          `,
        },
        {
          content: `
            Tenders will be opened online as per the e-Auction schedule, ensuring transparency without requiring bidder presence.
          `,
        },
        {
          content: `
            Bidders must disclose their status (Resident, Non-Resident, or Person of Indian Origin) and comply with the Foreign Exchange Management Act, 2000, if applicable.
          `,
        },
        {
          content: `
            The Authorized Officer can conduct e-Auctions and accept bids electronically, over the phone, or using any technology platform during the auction.
          `,
        },
      ],
    },
    {
      header: "DISCLAIMER",
      messages: [
        {
          content: "Responsibility and Liability",
          sub_content: [
            {
              content: `'${event?.bank?.name}' does not take responsibility for the quality or documentation details of the immovable secured assets being sold.`,
            },
            {
              content: `The bidders agree to defend, indemnify, and hold '${event?.bank?.name}' harmless from any loss, damage, cost, and expenses arising during this transaction.`,
            },
            {
              content: `Under no circumstances will '${event?.bank?.name}' be liable for any loss in business, revenues, profits, costs, direct and incidental, consequential, or punitive damages of any claim.`,
            },
            {
              content: `The particulars of the immovable secured assets specified herein have been stated to the best of the information and knowledge of the Authorised Officer. '${event?.bank?.name}' does not guarantee the accuracy of the information or details provided or the description of the immovable secured assets put up for online sale.`,
            },
            {
              content: `The Authorised Officer of '${event?.bank?.name}' shall not be liable for any error, misstatement, or omission regarding the same.`,
            },
          ],
        },
        {
          content: "Due Diligence by Bidders",
          sub_content: [
            {
              content:
                "Bidders should satisfy themselves on the title, ownership, and statutory approvals before participating in the auction.",
            },
            {
              content: `'${event?.bank?.name}' shall not be liable for any dues/charges including outstanding water/service charges, transfer fees, contribution to the building repair fund, electricity dues, dues/arrears of the Municipal Corporation/local authority/Society/Builder, taxes, and/or dues of any other nature in respect of the immovable secured assets.`,
            },
            {
              content: `'${event?.bank?.name}' does not undertake any responsibility to procure any permission/license concerning the immovable secured assets offered for online sale through e-Auction.`,
            },
          ],
        },
        {
          content: "Partial Eligibility",
          sub_content: [
            {
              content: `'${event?.bank?.name}' employees or its group companies' employees can participate in the e-Auction from the second auction onwards. They must follow the formalities like any ordinary bidder, and no deviations from the laid-down procedures will be allowed. Their candidature will be considered only when there is more than one bidder. Employees of the DSMG department cannot participate in the e-Auction.`,
            },
            {
              content: `Any existing vendor of '${event?.bank?.name}'/Group companies, specifically in roles such as Collection Agency, Enforcement Agency, Valuer, or Auction vendor, is not eligible to participate in the e-Auction.`,
            },
          ],
        },
        {
          content: "Confidentiality and Bidding Process",
          sub_content: [
            {
              content: `The Bidder shall not divulge their bids or any other exclusive details of '${event?.bank?.name}' to any other party.`,
            },
            {
              content:
                "The slab in multiples for bid improvements shall be at the sole discretion of the Authorised Officer and will be announced to the bidders before the commencement of the bidding process. The Authorised Officer has full liberty to revise the slab before the close of the e-Auction. No Bidder shall raise any objection regarding the slab fixed by the Authorised Officer.",
            },
          ],
        },
        {
          content: "Severability Clause",
          sub_content: [
            {
              content:
                "If any provision, clause, term, or condition of this document or any other document executed by the bidders is held or declared invalid by a court of competent jurisdiction, all other provisions, clauses, terms, or conditions shall remain in full force and effect.",
            },
          ],
        },
        {
          content: "Bidder's Agreement",
          sub_content: [
            {
              content:
                "By participating in the e-Auction, the bidder agrees to the following terms and conditions:",
            },
            {
              content:
                "It is the bidder's sole responsibility to procure their login ID and password from the e-Auction vendor.",
            },
            {
              content:
                "The bidder is solely responsible for the security and confidentiality of their registered login ID and password.",
            },
            {
              content: `'${event?.bank?.name}' and the e-Auction vendor shall not be responsible for any misuse of the bidder's login ID and password.`,
            },
            {
              content: `'${event?.bank?.name}' and the e-Auction vendor do not guarantee any bidder becoming a successful bidder.`,
            },
            {
              content: `'${event?.bank?.name}' and the e-Auction vendor are not responsible for any interruptions due to connectivity or technical issues.`,
            },
            {
              content: `'${event?.bank?.name}' and the e-Auction vendor will not entertain any loss caused by sharing the login ID or password or unauthorized login from the registered account.`,
            },
            {
              content:
                "The e-Auction vendor will use reasonable care to provide a robust online bidding platform.",
            },
            {
              content:
                "The e-Auction vendor shall not be liable for any claim, damage, or other loss suffered, including consequential loss due to technical issues or any incorrect or omitted information by the e-Auction vendor, its employees, agents, or any other party.",
            },
            {
              content: `Use of the online bidding platform is at the bidder's own risk. '${event?.bank?.name}' and the e-Auction vendor do not give any express or implied guarantees. Under no circumstances will '${event?.bank?.name}' and the e-Auction vendor be liable for damages arising out of the use or inability to use the online bidding platform.`,
            },
            {
              content:
                "No person employed by the e-Auction vendor has the authority to give any representation or guarantee regarding the online bidding platform.",
            },
            {
              content:
                "All bidders must read the terms and conditions on the bidding platform and agree that logging on to the platform means acceptance of all the above disclosures.",
            },
            {
              content:
                "By proceeding, bidders acknowledge and agree to abide by these terms and conditions.",
            },
          ],
        },
      ],
    },
  ];

  const definitions = [
    {
      header: `DEFINITION`,
      subheader: "Seller (Secured Creditor):",
      content: `The person or institution selling property under the SARFAESI Act, 2002, referred to as the "Secured Creditor," using online platforms under the name '${event?.bank?.name}'.`,
    },
    {
      subheader: "Bidder:",
      content: `Anyone, whether an individual, business owner, or company, participating in the auction by paying the required deposit. An individual can bid for themselves or on behalf of a company, but they need to register separately for each role and pay separate deposits.`,
    },
    {
      subheader: "Immovable Secured Asset:",
      content: `Property available for sale in an online auction.`,
    },
    {
      subheader: "Auctioneer/Web Portal:",
      content: `A company appointed by '${event?.bank?.name}' to conduct online auctions of secured assets under the SARFAESI Act. The company facilitates the auction process, including publishing events, assisting bidders, and providing reports to the authorized officer.`,
    },
    {
      subheader: "Marketing Agent:",
      content: `Agents appointed by '${event?.bank?.name}' to market the properties scheduled for auction, arrange property inspections, etc., as mentioned in the auction notice.`,
    },
    {
      subheader: "Terms and Conditions of Online Sale:",
      content: `All the rules and agreements governing the sale, including those in documents like the Invitation to Bid, Sale Notice, and any amendments made over time.`,
    },
  ];

  const declarationLetter = {
    header: "DECLARATION BY BIDDER",
    to: "The Authorised Officer",
    bankCompany: event?.bank?.name,
    cityBranch: event?.branch?.name,
    dearSirMadam: "Dear Sir/Madam,",
    subject: `SUB: Declaration for the purchase of immovable secure asset located at '${event?.event_name}'`,
    contents: [
      {
        sub_header: "Understanding and Acceptance:",
        content:
          "I/We have thoroughly reviewed and comprehended the terms and conditions outlined in the Public Notice, Tender cum Auction, and Invitation to Bid Document pertaining to the online sale of immovable secured assets. I/We acknowledge and accept these terms and conditions as binding upon me/us.",
      },
      {
        sub_header: "Intention to Purchase:",
        content:
          "It is my/our genuine intention to acquire the aforementioned immovable secured asset from [Bank/Company Name] for personal or commercial utilization.",
      },
      {
        sub_header: "Accuracy of Information:",
        content:
          "The information furnished by me/us in the Tender Document is truthful, accurate, and complete to the best of my/our knowledge, belief, and understanding.",
      },
      {
        sub_header: "Consequences of Non-Compliance:",
        content:
          "I/We understand and acknowledge that any material misrepresentation or default in fulfilling the obligations as per the Tender Document may result in the rejection of my/our bid, and I/we may be held liable for any resultant damages or losses suffered by [Bank/Company Name].",
      },
      {
        sub_header: "Legitimacy of Funds:",
        content:
          "The funds utilized for the Earnest Money Deposit and the sale consideration have been lawfully sourced and do not involve any proceeds derived from unlawful activities.",
      },
      {
        sub_header: "Indemnification:",
        content:
          "I/We hereby covenant and undertake to indemnify and hold harmless [Bank/Company Name] against any and all losses, liabilities, damages, costs, and expenses arising from any breach of the terms and conditions of sale or any inaccuracies in the information provided by me/us.",
      },
      {
        sub_header: "Risk Acknowledgment:",
        content:
          "I/We acknowledge the inherent risks associated with participating in an auction sale and have conducted due diligence by inspecting the property, reviewing relevant documentation, and making necessary inquiries.",
      },
      {
        sub_header: "Prohibition of Anti-Competitive Practices:",
        content:
          "I/We solemnly affirm that I/we shall refrain from engaging in any anti-competitive practices, collusion, or bid suppression activities with other bidders.",
      },
      {
        sub_header: "Acceptance of Bidding Slab:",
        content:
          "I/We acknowledge and agree that the determination of the bidding slab by the Authorised Officer of [Bank/Company Name] is at their sole discretion, and I/we shall not dispute or challenge the same.",
      },
    ],
    declarationLine:
      "I/We, the undersigned bidder(s), hereby affirm the following:",
    message:
      "This declaration is made in good faith and under the understanding of its legal implications.",
  };
  const form_constraints = {
    accept_terms_condition: {
      presence: {
        allowEmpty: false,
      },
    },
  };

  const getEventData = async () => {
    const response: any = await getAuctionEventByUuid(bidderData?.event_uuid);
    setEvent(response);
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
    form.setField("terms_condition_data", terms_condition_data);
    getEventData();
  }, []);

  const handleSubmit = async () => {
    let payload = bidderData;
    if (form.validate()) {
      form.startProcessing();
      payload.application_form_data["accept_terms_condition"] =
        form.value.terms_condition_data;
      payload.application_form_data["definitions"] = definitions;
      payload.application_form_data["declaration_letter"] = declarationLetter;
      const res = await updateBidderForEvent(payload);

      if (res) {
        payload["pdf_status"] = "generate_pdf";
        const resData = await updateBidderForEvent(payload);
        if (resData) {
          router.push(`/kyc/${id}?step=${nextStep}`);
        }
      }
      form.finishProcessing();
    }
  };

  console.log("bidderData", bidderData);

  return (
    <div className="min-h-screen ">
      <div className="mx-auto max-w-5xl border py-6 px-12 rounded-md space-y-6">
        <div className="flex flex-col justify-center items-center">
          <h2 className="font-bold tracking-wide text-2xl">
            Terms And Condition
          </h2>
          <p className="tracking-tighter pt-1 text-gray-400">
            Read the form carefully before proceeding
          </p>
        </div>
        <div className="flex flex-col max-h-[600px] overflow-hidden overflow-y-scroll gap-2">
          {terms_condition_data.map((item: any, index: number) => {
            return (
              <div
                className="flex flex-col justify-start items-start gap-2"
                key={index + "item"}
              >
                <h1 className="text-lg font-medium not-italic leading-8">
                  {item?.header}
                </h1>
                {item?.messages?.map((message: any, index: number) => (
                  <div
                    key={index + "message"}
                    className="flex justify-start gap-x-2 pl-4 gap-y-4"
                  >
                    <div className="flex flex-col gap-2">
                      <ul className="text-sm not-italic leading-6 font-normal list-disc">
                        <li className="list-disc"> {message.content}</li>
                      </ul>
                      {message?.sub_content && (
                        <ul className="flex flex-col pl-8 list-disc gap-1">
                          {message.sub_content.map(
                            (sub_item: any, sub_index: number) => {
                              return (
                                <li
                                  className="text-xs not-italic leading-4 font-normal list-disc"
                                  key={sub_index + "sub"}
                                >
                                  {sub_item.content}
                                </li>
                              );
                            }
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
        <div>
          <CheckboxBase
            labelBaseProps={{
              label:
                "I have read and agreed to the terms and conditions mentioned above.",
            }}
            htmlFor="accept_terms_condition"
            name="accept_terms_condition"
            type="text"
            value={form.getField("accept_terms_condition")}
            onChange={() =>
              form.setField(
                "accept_terms_condition",
                !form.getField("accept_terms_condition")
              )
            }
            checkboxBaseClasses={{
              textColor: "text-blue-700",
            }}
          />
        </div>
        <div className="flex justify-end text-center pt-2">
          <ButtonBase
            variant="primary"
            type="button"
            label={"Save & Submit"}
            onClick={() => handleSubmit()}
            buttonBaseClasses={{
              font: "text-base font-medium",
              backgroundColor: "bg-green-600 hover:bg-green-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-2",
            }}
            disabled={!form.getField("accept_terms_condition")}
            busy={form.busy}
            busyText={<Loader height="h-6" width="w-6" />}
          />
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
